import { Component, EventEmitter, OnInit, Output, viewChild } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { QuoteRefusalReasonService } from '../../../core/services/purchases/quote-refusal-reason/quote-refusal-reason.service'

@Component({
  selector: 'form-search-refused-quotes',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatTooltip,
    MatOption,
    MatSelect,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
  ],
  templateUrl: './form-search-refused-quotes.component.html',
  styleUrl: './form-search-refused-quotes.component.scss',
  standalone: true,
})
export class FormSearchRefusedQuotesComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private quoteRefusalReasonService: QuoteRefusalReasonService,
  ) {}

  @Output() responseSearch = new EventEmitter()

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  listReason: any[] = []

  ngOnInit() {
    this.createForm()
    this.getReasonsList()
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      codigoTg: [''],
      nomeEvento: [''],
      nomeCliente: [''],
      consultorComercial: [''],
      nomeConsultor: [''],
      motivoId: [''],
      dateStart: [''],
      dateEnd: [''],
    })
  }

  getReasonsList() {
    this.quoteRefusalReasonService.listQuoteRefusalReason().subscribe({
      next: (response: ResponseRequestModel) => {
        // lista vazia volta como 206 com data null
        this.listReason = response.data ?? []
      },
      error: () => {
        this.listReason = []
      },
    })
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  createModel() {
    return {
      codigoTg: this.formSearch.get('codigoTg')!.value,
      nomeEvento: this.formSearch.get('nomeEvento')!.value,
      nomeCliente: this.formSearch.get('nomeCliente')!.value,
      consultorComercial: this.formSearch.get('consultorComercial')!.value,
      nomeConsultor: this.formSearch.get('nomeConsultor')!.value,
      // MotivoId é int não anulável no backend, string vazia quebra a desserialização
      motivoId: this.formSearch.get('motivoId')!.value || 0,
      dataRecusaInicio: this.formatDate('dateStart'),
      dataRecusaFim: this.formatDate('dateEnd'),
    }
  }

  private formatDate(control: 'dateStart' | 'dateEnd') {
    const value = this.formSearch.get(control)!.value
    return value ? moment(value).format('DD/MM/YYYY') : ''
  }

  checkSearch() {
    const model: any = this.createModel()
    // motivoId zerado significa "Todos", não conta como filtro preenchido
    return Object.entries(model).some(([key, value]: [string, any]) =>
      key == 'motivoId' ? value > 0 : `${value ?? ''}`.trim().length > 0,
    )
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      this.responseSearch.emit({ search: true, model: this.createModel() })
    } else if (!search) {
      this.formSearch.reset({
        codigoTg: '',
        nomeEvento: '',
        nomeCliente: '',
        consultorComercial: '',
        nomeConsultor: '',
        motivoId: '',
        dateStart: '',
        dateEnd: '',
      })
      this.responseSearch.emit({ search: false, model: this.createModel() })
    }
  }
}
